'use strict';exports.__esModule = true;
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _uniqWith = require('lodash/uniqWith');var _uniqWith2 = _interopRequireDefault(_uniqWith);
var _cleanCoords = require('@turf/clean-coords');var _cleanCoords2 = _interopRequireDefault(_cleanCoords);
var _unkinkPolygon = require('@turf/unkink-polygon');var _unkinkPolygon2 = _interopRequireDefault(_unkinkPolygon);
var _geojsonHelpers = require('./geojson-helpers');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}




var formatDrawnPolygon = function formatDrawnPolygon(drawnPolyCoordinates) {
  var result = {};

  if (drawnPolyCoordinates && drawnPolyCoordinates.length > 0) {
    var uniq = (0, _uniqWith2.default)(drawnPolyCoordinates, _isEqual2.default);
    uniq.push(drawnPolyCoordinates[0]);

    var polyFeature = (0, _geojsonHelpers.createFeature)((0, _geojsonHelpers.createPolygon)([uniq]));
    var clearedPoly = (0, _cleanCoords2.default)(polyFeature);
    result = (0, _unkinkPolygon2.default)(clearedPoly);
  }

  return result;
}; /* eslint-disable max-statements, max-depth */exports.default =

formatDrawnPolygon;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MapContainer/drawn-polygon-query.js
// module id = 2980
// module chunks = 0